import React from "react";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { ClusterCard } from "@radarly/models/cards";
import { isImageClusteringDataviz } from "@radarly/models/dataviz";
import { useFragment } from "../fragment";
import { CardProps } from "../model";
import ImageClustering from "./image-clustering";

const RadarlyClustersCards = ({
  card,
  clause,
  from,
  to,
  height,
  openPostsPanel,
  timezone,
  forceReload,
  readOnly,
  nowDate,
}: CardProps<ClusterCard>) => {
  const project = useCurrentProject();
  const fragment = useFragment(card.fragments[0], clause, from, to, timezone);
  const dataviz = card.dataviz;

  return isImageClusteringDataviz(dataviz) ? (
    <ImageClustering
      fragment={fragment}
      project={project}
      dataviz={dataviz}
      title={card.title}
      height={height}
      openPostsPanel={readOnly ? null : openPostsPanel}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
    />
  ) : null;
};

export default RadarlyClustersCards;
